import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconUserGroup } from '../../../base/icons/svg';
// import CircularLabel from '../../../base/label/components/web/CircularLabel';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { getVisitorsShortText, iAmVisitor } from '../../functions';
import { CircularLabel } from '../../../base/label';
const useStyles = makeStyles()(theme => {
    return {
        label: {
            backgroundColor: theme.palette.warning02,
            color: theme.palette.uiBackground
        }
    };
});
const VisitorsCountLabel = () => {
    const { classes: styles, theme } = useStyles();
    const visitorsMode = useSelector((state) => iAmVisitor(state));
    const visitorsCount = useSelector((state) => state['features/visitors'].count || 0);
    const { t } = useTranslation();
    return !visitorsMode && visitorsCount > 0 ? (React.createElement(Tooltip, { className: '', content: t('visitors.labelTooltip', { count: visitorsCount }), position: 'bottom' },
        React.createElement(CircularLabel, { className: styles.label, icon: IconUserGroup, id: 'visitorsCountLabel', label: `${getVisitorsShortText(visitorsCount)}` }))) : null;
};
export default VisitorsCountLabel;
